import React from "react";
import { Box } from "@mui/material";
import {
  HEADER_HEIGHT,
  SIDEBAR_MAXWIDTH,
  SIDEBAR_MINWIDTH,
} from "../../../../utils/ui.constants";
import SidebarSmall from "./sidebar-small/SidebarSmall";
import SidebarWide from "./sidebar-wide/SidebarWide";

interface ISidebar {
  expand: true | false;
}

function Sidebar({ expand }: ISidebar) {
  return (
    <Box
      className="hidden-scroll"
      sx={{
        width: expand ? SIDEBAR_MAXWIDTH : SIDEBAR_MINWIDTH,
        height: `calc(100vh - ${HEADER_HEIGHT})`,
        backgroundColor: "background.paper",
        position: "relative",
        transition: "all linear 0.1s",
        overflow: "auto",
      }}
    >
      {/* curve */}
      {/* <Box
        sx={{
          position: "absolute",
          zIndex: 1,
          top: 0,
          right: "-15px",
          width: "15px",
          height: "15px",
          backgroundColor: "background.default",
          borderRadius: "50%",
          color: "background.paper",
          boxShadow: "-10px -10px 0px 0px currentColor",
        }}
      ></Box> */}
      {/* curve end */}
      {/* Content */}
      {expand ? <SidebarWide /> : <SidebarSmall />}
      {/* Content end */}
    </Box>
  );
}

export default Sidebar;
